export const POLICY_VERSION = 'v1';

export interface PolicyItem {
  key: string;
  title: string;
  text: string;
}

export const POLICY_LIST: PolicyItem[] = [
  { key: 'attendance', title: 'Attendance Policy',              text: 'I will mark daily check-in / check-out accurately and follow the attendance, late-login and regularisation rules.' },
  { key: 'leave',      title: 'Leave Policy',                   text: 'I have read the leave policy, including notice periods, approval flow, leave types and entitlements.' },
  { key: 'compoff',    title: 'Comp-off Policy',                text: 'I understand how compensatory off is earned, approved and availed.' },
  { key: 'nightshift', title: 'Night Shift / Shift Rules',      text: 'I agree to the shift assignment and night-shift working rules where applicable.' },
  { key: 'conduct',    title: 'Code of Conduct',                text: 'I agree to abide by the organisation\'s code of conduct and workplace policies.' },
  { key: 'privacy',    title: 'Data Privacy & Confidentiality', text: 'I will protect confidential information and comply with the data privacy (DPDP) policy.' },
];
